import React, { PropTypes, Component } from 'react';
import styles from './ConversionStep.css';
import withStyles from '../../decorators/withStyles';
import ExtrusionSettings from '../ExtrusionSettings';
import Steps from '../../actions/StepsActionCreator';
import Link from '../Link';
import BetaInfo from '../BetaInfo';

@withStyles(styles)
class ConversionStep extends Component {
  static propTypes = {
    steps: PropTypes.object,
    name: PropTypes.string,

    svgId: PropTypes.string.isRequired,
    conversions: PropTypes.array
  };

  static defaultProps = {
    conversions: []
  };

  constructor(props) {
    super(props);

    this._submit = this._submit.bind(this);
    this._changeHeight = this._changeHeight.bind(this);
  }

  componentDidMount() {
    Steps.setUploadId(this.props.svgId);
  }

  _changeHeight(height) {
    Steps.setHeight(height);
    Steps.setUploadId(this.props.svgId);
  }

  _submit() {
    Steps.convert();
  }

  formatConversions() {
    return this.props.conversions.map(function(item) {
      var url = '/download/' + item._id;

      return (
        <li key={item._id}>
          <a href={url} onClick={Link.handleClick}>Show {item.height}mm STL</a>
        </li>
      );
    });
  }

  render() {
    var image = '/api/preview/' + this.props.svgId;
    return (
      <div className="ConversionStep">
        <div className="row">
          <div className="col-md-4 small-padding">
            <div className="alert alert-info">
              This is a preview of <strong>{this.props.name}</strong>. Everything you see here will be extruded.
              <br /><br />
              <BetaInfo />
            </div>
          </div>

          <div className="col-md-4 small-padding">
            <ExtrusionSettings
              steps={this.props.steps}
              enabled={!this.props.steps.error}
              submit={this._submit}
              change={this._changeHeight}
            />
            <div>
              <img src={image} />
            </div>
          </div>

          <div className="col-md-4 small-padding">
            {this.props.steps.error &&
            <div className="alert alert-danger" role="alert">
              <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
              &nbsp;{this.props.steps.errorMessage}
            </div>
            }

            {this.props.conversions.length > 0 &&
              <div className="alert alert-info">
                <p><strong>{this.props.name}</strong> has already been extruded in the following heights:</p>
                <ul>
                  {this.formatConversions()}
                </ul>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default ConversionStep;



/** WEBPACK FOOTER **
 ** ./src/components/ConversionStep/ConversionStep.js
 **/